// extracted by mini-css-extract-plugin
module.exports = {"banner":"ProductArchivedBanner_banner__YIWRB","banner-text":"ProductArchivedBanner_banner-text__Je1lQ","banner-icon":"ProductArchivedBanner_banner-icon__bjycq"};